import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnName = {
  path: 'name',
  sort: 'name',
  width: '100%',
  link: '/languages/:_id/config',
};

export const ADMIN = [
  columnName,
  columnCreatedAt,
  columnUpdatedAt,
];
